<template>
  <div>
    <DarkModeSwitcher />
    <div class="container">
      <div class="error-page flex flex-col items-center justify-center h-screen text-center">
        <div class="text-white">
          <div class="intro-x text-8xl font-medium">403</div>
          <div class="intro-x text-xl lg:text-3xl font-medium mt-5">
            Unauthorized access
          </div>
          <div class="intro-x text-lg mt-3">
            You do not have permission to view this page.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted } from 'vue'
import DarkModeSwitcher from '@/components/dark-mode-switcher/Main.vue'

export default defineComponent({
  components: {
    DarkModeSwitcher
  },
  setup() {
    onMounted(() => {
      cash('body')
        .removeClass('main')
        .removeClass('login')
        .addClass('error-page')
    })
  }
})
</script>
